// LINE認可後のコールバック。code/stateを検証し、Workersの /auth/line へ。
//   連携済み → 即ログイン(/home) / 未連携 → 電話認証へ(/line/phone)
import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TailSpin } from 'react-loading-icons';
import { toast } from 'react-toastify';
import { Post } from '../compornents/Post';
import { lineRedirectUri } from '../compornents/LineButton';

export function LineCallback() {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      const code = sp.get('code');
      const state = sp.get('state');
      const err = sp.get('error');
      const savedState = sessionStorage.getItem('line_state');
      const flow = sessionStorage.getItem('line_flow') || 'login';
      sessionStorage.removeItem('line_state');
      sessionStorage.removeItem('line_flow');

      if (err || !code) {
        toast.error('LINEログインをキャンセルしました');
        navigate('/login');
        return;
      }
      // CSRF対策のstate検証。Safari→LINEアプリ→既定ブラウザ(Chrome等)で戻ると
      // sessionStorageが引き継がれず savedState が空になるため、その場合は続行を許可する
      // （認可コード自体は当チャネル＋当コールバックURLに紐づくため実害は限定的）。
      // savedState が存在するのに不一致の場合のみ改ざんとみなして拒否する。
      if (savedState && state !== savedState) {
        toast.error('セッションが無効です。お手数ですが最初からお試しください');
        navigate('/login');
        return;
      }

      const res = await Post('login', '/auth/line.php', { code, redirect_uri: lineRedirectUri() });
      if (res.result !== 1) {
        toast.error(res.error_message || 'LINEログインに失敗しました');
        navigate('/login');
        return;
      }

      // マイページからの連携フロー: ログイン済みのまま既存アカウントへ紐付け
      if (flow === 'link') {
        if (res.sec) {
          // このLINEは既にどこかのアカウントでログイン可能（＝連携済み）
          toast.info('このLINEアカウントは既に連携されています');
          navigate('/account');
          return;
        }
        if (res.line_token) {
          const linkRes = await Post('post', '/auth/line_link.php', { line_token: res.line_token });
          if (linkRes.result === 1) toast.success('LINE連携が完了しました！次回からLINEでログインできます');
          else toast.error(linkRes.error_message || 'LINE連携に失敗しました');
          navigate('/account');
          return;
        }
        navigate('/account');
        return;
      }

      if (res.sec) {
        // 連携済み → 即ログイン
        navigate('/home');
        return;
      }
      if (res.need_phone) {
        // 未連携 → 電話番号認証へ（LINE認証済みを line_token で受け渡す）
        sessionStorage.setItem('line_token', res.line_token);
        if (res.line_profile) sessionStorage.setItem('line_profile', JSON.stringify(res.line_profile));
        navigate('/line/phone');
        return;
      }
      navigate('/login');
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '70vh', gap: '16px' }}>
        <TailSpin stroke="#06C755" />
        <div style={{ color: 'var(--ink-2)' }}>LINEログイン処理中…</div>
      </div>
    </div>
  );
}

export default LineCallback;
